
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/riverpro-firmware-update-guide",
      function () {
        return require("private-next-pages/riverpro-firmware-update-guide/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/riverpro-firmware-update-guide"])
      });
    }
  